export default __webpack_public_path__ + "static/media/sounds/TRO_Today_You_Are_Going_To_Read.mp3";